// import { Boot, SlateElement } from '@wangeditor/editor'
// 生成 html 的函数
function fn(elem, childrenHtml) {
  console.log(elem, childrenHtml);
  let  { a, b, c,d,imId} = elem;
  a = a.split(',')[0]
  const res = `<div onclick="goOfficialAccounts('${imId}','${b}')" class='classes'>
    <div class="OfficialAccounts">
      <div class="top">
        <div class="left">
        <img src='${a}' alt="" />
        </div>
        <div class="center">
          <div class="center-top">${b}</div>
          <div class="center-bottom">${c}</div>
        </div>
        <div class="right"> <i class="el-icon-arrow-right cubeic-arrow"></i></div>
      </div>
      <div class="bottom">
      ${d}
      </div>
    </div>
  </div>`
  return res
}
// 配置
const conf = {
    type: 'OfficialAccounts', // 节点 type ，重要！！！
    elemToHtml: fn,
}

export default conf
